// 商品カードの色見本: マウスを乗せた色の写真にカードの写真を差し替える(クリックは通常のリンク移動)
(function () {
  if (!window.matchMedia('(hover: hover)').matches) return;

  function cardImage(swatch) {
    var card = swatch.closest('.card-wrapper');
    return card && { card: card, img: card.querySelector('.card__media .media img') };
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.gl-swatch[data-src]');
    if (!swatch) return;
    var t = cardImage(swatch);
    if (!t || !t.img) return;
    if (!t.img.dataset.glOrigSrc) {
      t.img.dataset.glOrigSrc = t.img.getAttribute('src') || '';
      t.img.dataset.glOrigSrcset = t.img.getAttribute('srcset') || '';
    }
    t.img.setAttribute('srcset', swatch.dataset.srcset);
    t.img.setAttribute('src', swatch.dataset.src);
    t.card.classList.add('gl-swatch-preview');
    t.card.querySelectorAll('.gl-swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  });

  // 色見本の列から離れたら、元の写真に戻す
  document.addEventListener('mouseout', function (e) {
    var list = e.target.closest && e.target.closest('.gl-swatches');
    if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
    var card = list.closest('.card-wrapper');
    var img = card && card.querySelector('.card__media .media img');
    if (!img || !img.dataset.glOrigSrc) return;
    img.setAttribute('srcset', img.dataset.glOrigSrcset);
    img.setAttribute('src', img.dataset.glOrigSrc);
    card.classList.remove('gl-swatch-preview');
    card.querySelectorAll('.gl-swatch.is-active').forEach(function (s) { s.classList.remove('is-active'); });
  });
})();
